module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/checkBack/nfl/survive-d778795b08456a915ea0ae6ba0d541d0.svg";